<template>
    <div class="header_row header-container">
      <div class="logo_container d-flex flex-row justify-content-between">
        <router-link to="/home">
          <img class="logo logo_icon" src="../assets/new_logo.png" alt="Home">
        </router-link>
        <div class="humbbar flex-column justify-content-center" id="humbbar">
          <a href="javascript:void(0);" class="icon m-auto" @click="toggleMenu">
            <svg xmlns="http://www.w3.org/2000/svg" height="36px" width="36px" viewBox="0 0 448 512">
              <path d="M0 96C0 78.33 14.33 64 32 64H416C433.7 64 448 78.33 448 96C448 113.7 433.7 128 416 128H32C14.33 128 0 113.7 0 96zM0 256C0 238.3 14.33 224 32 224H416C433.7 224 448 238.3 448 256C448 273.7 433.7 288 416 288H32C14.33 288 0 273.7 0 256zM416 448H32C14.33 448 0 433.7 0 416C0 398.3 14.33 384 32 384H416C433.7 384 448 398.3 448 416C448 433.7 433.7 448 416 448z"/>
            </svg>
          </a>
        </div>
      </div>
      
   <div class="links flex-row" id="links" :class="{ 'mobile-visible': menuVisible }" style="width: -webkit-fill-available">
  <!-- POS -->
<router-link 
  to="/pos" 
  class="element"
  @click="(e) => { e.preventDefault(); forceRefreshPos() }"
>
  <div 
    class="centered pos" 
    :class="{ 'active': $route.path === '/pos' }" 
    v-if="$hasPermission('view orders')"
  >
    POS  
  </div>
</router-link>

  <!-- Dine-In -->
  <router-link 
    v-if="$hasPermission('dienin order')" 
    to="/dinein" 
    class="centered dinein" 
    :class="{ 'active': $route.path === '/dinein' }"
  >
    <span class="element">Dine-In</span>
  </router-link>

  <!-- Takeaway -->
  <router-link 
    v-if="$hasPermission('takeaway order')" 
    to="/takeaway" 
    class="centered takeaway" 
    :class="{ 'active': $route.path === '/takeaway' }"
  >
    <span class="element">Takeaway</span>
  </router-link>

  <!-- Delivery -->
  <router-link 
    v-if="$hasPermission('delivery order')" 
    to="/delivery" 
    class="centered delivery" 
    :class="{ 'active': $route.path === '/delivery' }"
  >
    <span class="element">Delivery</span>
  </router-link>

  <!-- Bills -->
   <router-link to="/bills" class="element">
  <div class="centered bills" :class="{ 'active': $route.path === '/bills' }" v-if="$hasPermission('view orders')">
    
      Bills
  </div>
      </router-link>

</div>  
      
      <div class="righttext text-right d-flex flex-row">
        <div class="d-flex flex-column justify-content-center">
          <div>{{ username }}</div>
          <!-- <div>{{ branch }}</div> -->
          <div>  
            <span>{{ currentDate }}</span>
            <span> | </span>
            <span>{{ currentTime }}</span>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'AppHeader',
    data() {
      return {
        currentDate: '',
        currentTime: '',
        username: localStorage.getItem('username') || 'Username',
        branch: localStorage.getItem('branchName') || 'Restaurant Name',
        menuVisible: false
      };
    },
    mounted() {
      this.updateDateTime();
      this.startDateTimeUpdate();
    },
    methods: {
       forceRefreshPos() {
    if (this.$route.path !== '/pos') {
      window.location.href = '/viamenu/pos'; 
    }
  },
      updateDateTime() {
        const now = new Date();
        this.currentDate = now.toLocaleDateString('en-GB', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
        });
        this.currentTime = now.toLocaleTimeString('en-US', {
          hour: '2-digit',
          minute: '2-digit',
          hour12: true,
        });
      },
      startDateTimeUpdate() {
        setInterval(() => {
          this.updateDateTime();
        }, 1000);
      },
      toggleMenu() {
        this.menuVisible = !this.menuVisible;
      }
    }
  };
  </script>
<style>
.active {
  text-decoration-line: underline;
  color: #fff;
}
</style>